module.exports = __webpack_public_path__ + "static/media/line-graph.ca13ec1c.png";